import React, { Component } from 'react';
import { Link } from 'react-router';
import ReactDOM from 'react-dom';
import Translate from '../layout/Translate';
import {translateX, translateY} from 'react-imation/tween-value-factories';
import Swipeable from 'react-swipeable';
import ReactPlayer from 'react-player'

export default class Gallery extends Component {


    componentWillMount() {
        this.photoRefs = [];
    }

    componentDidMount() {
        let photoRefs = [];
        let refs = this.refs;
        this.props.gallery.list.forEach(function(photo, index){
            photoRefs.push(ReactDOM.findDOMNode(refs["photo" + index]));
        });


        this.photoRefs = photoRefs;
    }



    playVideo(index) {
        this.props.actions.playVideo(index);
    }


    selectPhoto(index, toNext, isPoint, active) {
        if (active) {
            if (toNext && index == this.props.gallery.activePhoto && !isPoint) {
                this.props.actions.selectPhoto((this.props.gallery.list.length > index+1)?index+1:0);
            } else {
                this.props.actions.selectPhoto(index);
            }
        }
    }

    swipedRight(e, deltaX, deltaY, absX, absY, velocity) {
        this.props.actions.selectPhoto((0 > this.props.gallery.activePhoto-1)?this.props.gallery.list.length-1:this.props.gallery.activePhoto-1);
    }
    swipedLeft(e, deltaX, deltaY, absX, absY, velocity) {
        this.props.actions.selectPhoto((this.props.gallery.list.length > this.props.gallery.activePhoto+1)?this.props.gallery.activePhoto+1:0);
    }
    swiping(e, deltaX, deltaY, absX, absY, velocity) {
        this.props.actions.swipeGallery(deltaX)
    }

    render () {
        let { gallery, size } = this.props;

        let refs = this.refs;
        let offset = 0;

        this.props.gallery.list.forEach(function(photo, index){
            if (gallery.activePhoto > index) {
                offset -= (parseInt((ReactDOM.findDOMNode(refs["photo" + index]) && ReactDOM.findDOMNode(refs["photo" + index]).clientWidth)?ReactDOM.findDOMNode(refs["photo" + index]).clientWidth:0) + 6);
            }

        });

        offset -= gallery.delta;
        let center = 8;
        if (gallery.activePhoto < 8) {
            center = 16 -  gallery.activePhoto;
        } else if (gallery.list.length - gallery.activePhoto < 8) {
            center = 16 - (gallery.list.length - gallery.activePhoto);
        }

        return (
            <section ref="photos" className={"section section__photos gallery"}>


                {gallery && !!gallery.list.length &&

                <div>
                <div className="container">
                    <div className="tour__title">
                        <Translate slug="tour__photos" />
                    </div>
                </div>
                    <Swipeable
                        onSwipedRight={this.swipedRight.bind(this)}
                        onSwiping={this.swiping.bind(this)}
                        onSwipedLeft={this.swipedLeft.bind(this)} >
                        <div className="gallery__photos">

                            <div className={"gallery__line " + (gallery.delta?"gallery__line_swiping":"")} style={{marginLeft: this.props.offset, transform: 'translate('+offset+'px)'}}>
                                {gallery.list.map((photo,index)=><div onClick={this.selectPhoto.bind(this, index, true, false, !(photo.config && photo.config.video))} className={"gallery__photo " + ((gallery.activePhoto==index)?"gallery__photo_active":"") + (!(photo.config && photo.config.video)?" gallery__photo_image":"")}
                                                                    key={index} data-id={photo.id}>
                                        {(photo.config && photo.config.video) &&
                                            <div className="gallery__wrapper">
                                                {!photo.play &&
                                                <div className="gallery__play"
                                                     style={{backgroundImage: 'url(' + ((photo.thumbnails['browsing' + size])?photo.thumbnails['browsing' + size].url:"") + ')'}}
                                                     onClick={this.playVideo.bind(this, index)} />
                                                }
                                                <ReactPlayer
                                                    url={'https://vimeo.com/' + photo.config.video}
                                                    vimeoConfig={{preload: true}}
                                                    playing={photo.play}
                                                    className="gallery__video"
                                                    ref={"photo" + index}
                                                    controls={photo.play}
                                                />
                                            </div>
                                        }
                                        {(((photo.config && !photo.config.video) || !photo.config)) &&
                                            <img alt={photo.title}
                                                 dataWidth={(ReactDOM.findDOMNode(this.refs["photo" + index]) && ReactDOM.findDOMNode(this.refs["photo" + index]).clientWidth)?ReactDOM.findDOMNode(this.refs["photo" + index]).clientWidth:""}
                                                 className="gallery__image"
                                                 src={((photo.thumbnails['browsing' + size])?photo.thumbnails['browsing' + size].url:"")}
                                                 ref={"photo" + index}
                                            />
                                        }
                                        <div className="open"></div>
                                    </div>)}
                            </div>
                        </div>
                    </Swipeable>

                    <ul className="gallery__menu">
                        {gallery.list.map((photo,index)=>
                            <li className={"gallery__point " +
                                ((gallery.activePhoto===index)?"gallery__point_active":"")+
                                ((photo.config && photo.config.video)?" gallery__point_video":"") +
                                ((photo.config && photo.config.video && (gallery.activePhoto===index))?" gallery__point_video_active":"") +
                                (" gallery__point" + (index < gallery.activePhoto ? "_prev" : "")) +
                                (" gallery__point" + (index > gallery.activePhoto ? "_next" : "")) +
                                (" gallery__point" + (index + center === gallery.activePhoto ? "_prev_5" : "")) +
                                (" gallery__point" + (index - center === gallery.activePhoto ? "_next_5" : "")) +
                                (" gallery__point" + (index + center < gallery.activePhoto ? "_prev_after_5" : "")) +
                                (" gallery__point" + (index - center > gallery.activePhoto ? "_next_after_5" : ""))
                            }
                                onClick={this.selectPhoto.bind(this, index, true, true)} />
                        )}
                    </ul>

                    </div>
                }
            </section>



        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/tour/Gallery.js